"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.record.id': 'ID Zapisu',
    'onboarding.record.progress': 'Postęp',
    'onboarding.record.created': 'Utworzony',
    'onboarding.record.updated': 'Ostatnia Aktualizacja',
    'onboarding.record.view': 'Zobacz Szczegóły',
    'onboarding.record.continue': 'Kontynuuj',
};
